// extracted by mini-css-extract-plugin
export default {"container":"RcDJh","noSpacing":"a5wO1","noSpacingTop":"H2g1N"};